import React, { useState, useEffect } from 'react';
import superagent from 'superagent';
import { backendUrl } from 'helpers/consts';
import { formatDateTimeLocal } from '@utilities/utilities';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@shadcn/components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@shadcn/components/ui/select';
import { Button } from '@shadcn/components/ui/button';

const timerOptions = [
  { label: '30 minutes', value: '30' },
  { label: '1 hour', value: '60' },
  { label: '2 hours', value: '120' },
  { label: '4 hours', value: '240' },
  { label: '8 hours', value: '480' },
  { label: '24 hours', value: '1440' },
  { label: '48 hours', value: '2880' },
  { label: '1 week', value: '10080' },
  { label: 'Custom', value: 'custom' },
];

const EditUnflagTimeModal = ({ togglemodal, refresh, orderID, isOpen, currentUnflagAt }) => {
  const [loading, setLoading] = useState(false);
  const [timerDuration, setTimerDuration] = useState('');
  
  const [customDateTime, setCustomDateTime] = useState(
    currentUnflagAt ? formatDateTimeLocal(currentUnflagAt) : ''
  );

  useEffect(() => {
    if (currentUnflagAt) {
      setTimerDuration('custom');
      setCustomDateTime(formatDateTimeLocal(currentUnflagAt));
    }
  }, [currentUnflagAt]);

  const calculateUnflagAt = () => {
    if (!timerDuration) return null;
    
    if (timerDuration === 'custom') {
      if (!customDateTime) return null;
      return new Date(customDateTime);
    }
    
    const now = new Date();
    return new Date(now.getTime() + parseInt(timerDuration) * 60 * 1000);
  };

  const handleUpdate = () => {
    const unflagAt = calculateUnflagAt();
    
    setLoading(true);
    superagent
      .put(`${backendUrl}/orders/${orderID}/updateUnflagAt`)
      .send({ unflagAt })
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .set('accept', 'json')
      .on('error', (response) => {
        setLoading(false);
      })
      .then((response) => {
        const code = response.status;
        if (code > 400) {
        } else {
          refresh();
          togglemodal();
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleRemoveTimer = () => {
    setLoading(true);
    superagent
      .put(`${backendUrl}/orders/${orderID}/updateUnflagAt`)
      .send({ unflagAt: null })
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .set('accept', 'json')
      .on('error', (response) => {
        setLoading(false);
      })
      .then((response) => {
        const code = response.status;
        if (code > 400) {
        } else {
          refresh();
          togglemodal();
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <Dialog open={isOpen} onOpenChange={togglemodal}>
      {loading === true ? (
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Edit Auto-Unflag Time</DialogTitle>
          </DialogHeader>
          <div className="flex justify-center">
            <div className="spinner-border text-primary m-1" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </DialogContent>
      ) : (
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Edit Auto-Unflag Time</DialogTitle>
          </DialogHeader>
          <div>
            {currentUnflagAt && (
              <div className="mb-4 p-3 bg-yellow-50 rounded-md">
                <p className="text-sm text-yellow-700">
                  Current auto-unflag time: {new Date(currentUnflagAt).toLocaleString()}
                </p>
              </div>
            )}

            <label className="block text-sm font-medium text-gray-700 mb-2">
              New Auto-unflag Time
            </label>
            <Select value={timerDuration} onValueChange={(value) => setTimerDuration(value)}>
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select duration" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Duration</SelectLabel>
                  {timerOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>

            {timerDuration === 'custom' && (
              <div className="mt-3">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Custom Date & Time
                </label>
                <input
                  type="datetime-local"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={customDateTime}
                  onChange={(e) => setCustomDateTime(e.target.value)}
                />
              </div>
            )}

            {timerDuration && timerDuration !== 'custom' && (
              <p className="mt-2 text-sm text-gray-500">
                Order will be automatically unflagged at:{' '}
                {new Date(Date.now() + parseInt(timerDuration) * 60 * 1000).toLocaleString()}
              </p>
            )}

            {timerDuration === 'custom' && customDateTime && (
              <p className="mt-2 text-sm text-gray-500">
                Order will be automatically unflagged at:{' '}
                {new Date(customDateTime).toLocaleString()}
              </p>
            )}

            <br />
          </div>
          <DialogFooter className="flex gap-2">
            {currentUnflagAt && (
              <Button variant="destructive" onClick={handleRemoveTimer}>
                Remove Timer
              </Button>
            )}
            <Button onClick={handleUpdate} disabled={!timerDuration || (timerDuration === 'custom' && !customDateTime)}>
              Update
            </Button>
          </DialogFooter>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default EditUnflagTimeModal;
